import React from "react";
import "./menu_approval.css";
import { Button, Table, Tabs, Modal, Progress, Badge } from "antd";
import { GiCancel, GiCheckMark } from "react-icons/gi";
import { MdEditDocument } from "react-icons/md";
import { ApprovalData, useApprovalTable } from "./hoc_menu_approval";
import axios from "axios";
import WorkOrder from "../service/work_order";
import { UNSAFE_LocationContext, useLocation } from "react-router-dom";
import SalesEstimation from "../sales/sales_estimation";
import InvoiceReturnWorkOrder from "../service/invoice_return/invoice_return_work_order";
import SupplySlipReturn from "../service/supply_slip_return/supply_slip_return";
import SalesOrderInvoiceReturn from "../admin/sales_order_invoice_return";
import StatusImportSparepartsMaster from "../inventory/status_import_spareparts_master";
import Adjustment from "../inventory/adjusment/adjustment";
import PurchaseOrder from "../inventory/purchase_order";
import GoodsReceiveReturn from "../inventory/goods_receive_return";

const MenuApproval: React.FC = () => {
    const transformStyle = { transform: "scale(0.80)", transformOrigin: "top left", width: "125%" };
    const Acceptbtn = GiCheckMark as React.ComponentType<any>;
    const Revisebtn = MdEditDocument as React.ComponentType<any>;
    const Cancelbtn = GiCancel as React.ComponentType<any>;
    const [activeTab, setActiveTab] = React.useState("sales_order");
    const {
        columns,
        data,
        isLoading,
        selectedRowKeys,
        setSelectedRowKeys,
        handleAccept,
        handleRevise,
        handleReject,
        isRejectDisabled,
        isReviseDisabled,
        isProcessing
    } = useApprovalTable(activeTab);
    const [isWoModalOpen, setIsWoModalOpen] = React.useState(false);
    const [selectedWeNo, setSelectedWeNo] = React.useState<string | null>(null);
    const [isSoModalOpen, setIsSoModalOpen] = React.useState(false);
    const [selectedSeNo, setSelectedSeNo] = React.useState<string | null>(null);
    const [selectedSoData, setSelectedSoData] = React.useState<any>(null);
    const [isProgressModalOpen, setIsProgressModalOpen] = React.useState(false);
        const [progressPercent, setProgressPercent] = React.useState(0);
        const [detailModal, setDetailModal] = React.useState<{ title: string; width?: number | string; state?: any; Component: React.ComponentType<any> } | null>(null);
        const location = useLocation();
    const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 780);
    const longPressTimer = React.useRef<NodeJS.Timeout | null>(null);
    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 780);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleLongPress = (record: ApprovalData) => {
        longPressTimer.current = setTimeout(() => {
            Modal.confirm({
                title: "View Detail?",
                onOk: () => handleRowDoubleClick(record),
            });
        }, 1000);
    };
    const cancelLongPress = () => {
        if (longPressTimer.current) clearTimeout(longPressTimer.current);
    };
    const handleRowDoubleClick = async (record: ApprovalData) => {
        const code = String(record.code);
        if (code === "01" || code === "02") {
            setProgressPercent(0);
            setIsProgressModalOpen(true);
            let currentPercent = 0;
            const interval = setInterval(() => {
                currentPercent += Math.floor(Math.random() * 15) + 5;
                if (currentPercent >= 90) {
                    currentPercent = 90;
                    clearInterval(interval);
                }
                setProgressPercent(currentPercent);
            }, 100);
            if (code === "02") {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_BACKEND_URL}/api/approvals/work-order-estimation/${record.no_document}`,
                    );
                    if (response.data && response.data.work_estimation_no) {
                        clearInterval(interval);
                        setProgressPercent(100);
                        setTimeout(() => {
                            setIsProgressModalOpen(false);
                            setSelectedWeNo(response.data.work_estimation_no);
                            setIsWoModalOpen(true);
                        }, 300);
                    } else {
                        throw new Error("Invalid WO data");
                    }
                } catch (error) {
                    clearInterval(interval);
                    setIsProgressModalOpen(false);
                    console.error("Error fetching work estimation number:", error);
                }
            } else {
                try {
                    const response = await axios.get(
                        `${process.env.REACT_APP_BACKEND_URL}/api/approvals/sales-master/${record.no_document}`,
                    );
                    if (response.data) {
                        clearInterval(interval);
                        setProgressPercent(100);
                        setTimeout(() => {
                            setIsProgressModalOpen(false);
                            setSelectedSeNo(record.no_document);
                            setSelectedSoData(response.data);
                            setIsSoModalOpen(true);
                        }, 300);
                    } else {
                        throw new Error("Invalid SO data");
                    }
                } catch (error) {
                    clearInterval(interval);
                    setIsProgressModalOpen(false);
                    console.error("Error fetching sales master data:", error);
                }
            }
            return;
        }

        if (code === "03") {
                    const isReturnWO = record.return_work_order === '1' || record.return_work_order === 1;
                    if (isReturnWO) {
                        setDetailModal({
                            title: 'Invoice Return Work Order',
                            width: '95%',
                            state: { invoice_return_no: record.no_document },
                            Component: InvoiceReturnWorkOrder,
                        });
                    } else {
                        setDetailModal({
                            title: 'Supply Slip Return',
                            width: '95%',
                            state: { record: { supply_slip_return_no: record.no_document, status: '1' } },
                            Component: SupplySlipReturn,
                        });
                    }
                    return;
                }

                if (code === "04") {
                    try {
                        const response = await axios.get(
                            `${process.env.REACT_APP_BACKEND_URL}/api/sales-order-invoice-return/${record.no_document}`,
                        );
                        localStorage.setItem('selectedInvoiceReturnData', JSON.stringify(response.data));
                        setDetailModal({
                            title: 'Sales Order Invoice Return',
                            width: '95%',
                            Component: SalesOrderInvoiceReturn,
                        });
                    } catch (error) {
                        console.error("Error fetching sales order invoice return detail:", error);
                    }
                    return;
                }

                if (code === "05") {
                    setDetailModal({
                        title: 'Status Import Spareparts Master',
                        width: '95%',
                        Component: StatusImportSparepartsMaster,
                    });
                    return;
                }

                if (code === "06") {
                    const isInventory = record.inventory === '1' || record.inventory === 1;
                    if (isInventory) {
                        setDetailModal({
                            title: 'Adjustment',
                            width: '95%',
                            state: { adjustment_no: record.no_document },
                            Component: Adjustment,
                        });
                    } else {
                        setDetailModal({
                            title: 'Purchase Order',
                            width: '95%',
                            state: { poNo: record.no_document },
                            Component: PurchaseOrder,
                        });
                    }
                    return;
                }

                if (code === "07") {
                    setDetailModal({
                        title: 'Goods Receive Return',
                        width: '95%',
                        state: { goodsReceiveReturnNo: record.no_document },
                        Component: GoodsReceiveReturn,
                    });
                }
            };

    const getRowHandlers = (record: ApprovalData) => ({
        onDoubleClick: () => !isMobile && handleRowDoubleClick(record),
        onTouchStart: () => isMobile && handleLongPress(record),
        onTouchEnd: () => isMobile && cancelLongPress(),
        onTouchMove: () => isMobile && cancelLongPress(),
    });
    const hasData = data && data.length > 0;
    const buttonsDisabled = !hasData;

    const sparepartsColumns = columns.map((col) => {
        if (col.key === "remark") {
            return { ...col, title: "Request Change" };
        }
        if (col.key === "amount") {
            return { ...col, title: "Total" };
        }
        return col;
    });
    const tabItems = [
        {
            key: "sales_order",
            label: (
                <span>Sales Order <Badge count={data.filter((item) => item.code === "01").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={columns}
                    dataSource={data.filter((item) => item.code === "01") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
        {
            key: "work_order",
            label: (
                <span>Work Order <Badge count={data.filter((item) => item.code === "02").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={columns}
                    dataSource={data.filter((item) => item.code === "02") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
        {
            key: "return_sales_order",
            label: (
                <span>Return Sales Order <Badge count={data.filter((item) => item.code === "04").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={columns}
                    dataSource={data.filter((item) => item.code === "04") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
        {
            key: "return_work_order",
            label: (
                <span>Return Work Order <Badge count={data.filter((item) => item.code === "03").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={columns}
                    dataSource={data.filter((item) => item.code === "03") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
        {
            key: "spareparts_detail",
            label: (
                <span>Spareparts Detail <Badge count={data.filter((item) => item.code === "05").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={sparepartsColumns}
                    dataSource={data.filter((item) => item.code === "05") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
        {
            key: "inventory",
            label: (
                <span>Inventory <Badge count={data.filter((item) => item.code === "06").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={columns}
                    dataSource={data.filter((item) => item.code === "06") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
        {
            key: "return_gr",
            label: (
                <span>Return GR <Badge count={data.filter((item) => item.code === "07").length} showZero size="small" /></span>
            ),
            children: (
                <Table<ApprovalData>
                    rowSelection={{ type: "checkbox", selectedRowKeys, onChange: (keys) => setSelectedRowKeys(keys) }}
                    columns={columns}
                    dataSource={data.filter((item) => item.code === "07") as ApprovalData[]}
                    loading={isLoading}
                    onRow={getRowHandlers}
                />
            ),
        },
    ];

    return (
        <div id="ipg8" style={transformStyle}>
            <div className="gjs-grid-row" id="igx8y">
                <div className="gjs-grid-column" id="iatat">
                    <Button
                        className="gr-button"
                        onClick={handleAccept}
                        disabled={buttonsDisabled}
                        style={{ opacity: buttonsDisabled ? 1 : 1 }}>
                        <Acceptbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        Accept
                    </Button>
                    <Button
                        className="gr-button"
                        onClick={handleRevise}
                        disabled={buttonsDisabled || isReviseDisabled}
                        style={{ opacity: buttonsDisabled || isReviseDisabled ? 1 : 1 }}>
                        <Revisebtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        Revise
                    </Button>
                    <Button
                        className="gr-button"
                        onClick={handleReject}
                        disabled={buttonsDisabled || isRejectDisabled}
                        style={{ opacity: buttonsDisabled || isRejectDisabled ? 1 : 1 }}>
                        <Cancelbtn style={{ width: "1em", height: "1em", marginRight: "8px" }} />
                        Reject
                    </Button>
                </div>
            </div>

            <div className="gjs-grid-row" id="ivz33">
                <div className="gjs-grid-column" id="ikrwj">
                    <Tabs defaultActiveKey="sales_order" items={tabItems} onChange={(key) => { setActiveTab(key); setSelectedRowKeys([]); }} />
                </div>
            </div>
            <Modal
                open={isProgressModalOpen}
                footer={null}
                closable={false}
                centered
                width={300}
            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <Progress type="circle" percent={progressPercent} />
                    <div style={{ marginTop: 16, fontWeight: "bold" }}>Loading Data...</div>
                </div>
            </Modal>
            <Modal
                open={isProcessing}
                footer={null}
                closable={false}
                centered
                maskClosable={false}
                width={350}
            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <Progress status="active" percent={100} showInfo={false} strokeColor="#1677ff" />
                    <div style={{ marginTop: 16, fontWeight: "bold", fontSize: "16px" }}>Memproses ke Database...</div>
                    <div style={{ color: "#8c8c8c" }}>Mohon tunggu sebentar, jangan menutup halaman.</div>
                </div>
            </Modal>
            <Modal
                title="Work Order Detail"
                open={isWoModalOpen}
                onCancel={() => {
                    setIsWoModalOpen(false);
                    setSelectedWeNo(null);
                }}
                width="95%"
                style={{ top: 20 }}
                footer={null}
                destroyOnClose>
                {selectedWeNo && (
                    <div className="work_order-wrapper" style={{ overflowX: "auto", maxWidth: "100%" }}>
                        <WorkOrder weNo={selectedWeNo} />
                    </div>
                )}
            </Modal>
            <Modal
                title="Sales Order Detail"
                open={isSoModalOpen}
                onCancel={() => {
                    setIsSoModalOpen(false);
                    setSelectedSeNo(null);
                    setSelectedSoData(null);
                }}
                width="95%"
                style={{ top: 20 }}
                footer={null}
                destroyOnClose>
                {selectedSeNo && selectedSoData && (
                    <div className="sales_estimation-wrapper" style={{ overflowX: "auto", maxWidth: "100%" }}>
                        <SalesEstimation editData={selectedSoData} />
                    </div>
                )}
            </Modal>
            <Modal
                title={detailModal?.title}
                open={!!detailModal}
                onCancel={() => setDetailModal(null)}
                width={detailModal?.width || '95%'}
                style={{ top: 20 }}
                footer={null}
                destroyOnClose
            >
                {detailModal && (() => {
                                    const DetailComponent = detailModal.Component;
                                    return (
                                        <UNSAFE_LocationContext.Provider value={{ location: { ...location, state: detailModal.state }, navigationType: 'POP' as any }}>
                                            <DetailComponent />
                                        </UNSAFE_LocationContext.Provider>
                                    );
                                })()}
            </Modal>
        </div>
    );
};

export default MenuApproval;
